import { render, staticRenderFns } from "./milestone.vue?vue&type=template&id=2734538a&"
import script from "./milestone.vue?vue&type=script&lang=ts&"
export * from "./milestone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports